module.exports = __webpack_public_path__ + "img/logo.6ca75c51.png";